import './App.css';
import MusicUi from "./Component/MusicUi";

function App() {
  return <MusicUi />;
}

export default App;